import {FC, useEffect, useState} from "react";
import {useSite} from "../../../../store/siteContext.ts";
import {getOpenIssues, Issue} from "../../../../api/issue.ts";
import {Column, FlexSpace, Row} from "../../../../atoms/Layout.tsx";
import AppBarWithNavigation from "../../../../organisms/AppBarWithNavigation.tsx";
import FullPageLoader from "../../../../templates/FullPageLoader.tsx";
import IssueList from "../../../../templates/IssueList.tsx";
import ContentArea from "../../../../atoms/ContentArea.tsx";
//import Button from "../../../../atoms/Button.tsx";
//import {useNavigate} from "react-router";

const OpenIssuesPage: FC = () => {
    const site = useSite();
    const [issues, setIssues] = useState<Issue[] | undefined>();
    //const navigate = useNavigate();

    useEffect(() => {
        getOpenIssues(site.id).then(setIssues);
    }, []);

    if (!issues) {
        return <Column grow>
            <AppBarWithNavigation />
            <FullPageLoader />
        </Column>
    }

    return <Column grow>
        <AppBarWithNavigation title="Live issues" />
        <ContentArea>
            <Column grow gap="32">
                <Row>
                    <FlexSpace />
                    {/*<Button size="small" onClick={() => navigate(`/u/dashboard/site/${site.id}/generate-report`)}>Generate Report</Button>*/}
                </Row>
                <IssueList issues={issues} />
            </Column>
        </ContentArea>
    </Column>
}

export default OpenIssuesPage;